

import { useState } from 'react';
import MobileHeader from './Header/MobileHeader';
import DesktopHeader from './Header/DesktopHeader';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';
import Footer from './Footer/Footer';
import ScrollToTop from './ScrollToTop';
import UJChatbot from './UJChatbot';
import ReportWidget from './ReportWidget';

const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = (newState) => {
        if (typeof newState === 'boolean') {
            setIsSidebarOpen(newState);
        } else {
            setIsSidebarOpen(false);
        }
    };

    return (
        <div className="relative min-h-screen text-white" style={{
            background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), #081423'
        }}>
            {                                    }
            <div className="absolute inset-0 w-full h-full pointer-events-none">
                <img
                    src="/images/stars.png"
                    alt="Background Stars"
                    className="w-full h-full object-cover opacity-80"
                />
            </div>

            {                                             }
            <div className="flex flex-row-reverse relative z-20 min-h-screen">
                {                                            }
                <div className="hidden md:block sticky top-0 h-screen z-[200]">
                    <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
                </div>

                {                            }
                <div className="flex-1 relative z-20 px-0 md:px-[70px]" style={{ maxWidth: '100vw' }}>
                    {                                            }
                    <div className="md:hidden">
                        <MobileHeader onToggleSidebar={toggleSidebar} />
                    </div>

                    {                                              }
                    <div className="hidden md:block">
                        <DesktopHeader />
                    </div>

                    <main className="relative z-20 md:z-200 md:pointer-events-auto md:pt-[70px]">
                        {children}
                    </main>
                    <Footer />
                    <MobileBottomNav />
                    <ScrollToTop />
                    <UJChatbot />
                    <ReportWidget />
                </div>
            </div>

            {                                                 }
            <div className="md:hidden">
                <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
            </div>
        </div>
    );
};

export default Layout;